import React from 'react';
import './LegalPage.css';

const EditorialPolicyPage = () => (
  <div className="legal-page">
    <h1>Editorial Policy</h1>
    <p className="legal-updated">Last updated: 1 July 2026</p>

    <p>
      Irish Visa Tracker publishes original guides, articles, and tools to help
      Indian applicants navigate the Irish visa process. This page describes how
      we create, review, and update our content.
    </p>

    <h2>1. What we publish</h2>
    <ul>
      <li>Long-form guides on student, work, tourist, dependent, and PR pathways.</li>
      <li>Premium planning tools such as readiness checklists, fee calculators, and processing-time estimators.</li>
      <li>Real-time alerts and historical analysis based on official NDVO data.</li>
    </ul>

    <h2>2. Sources we use</h2>
    <ul>
      <li>
        <a href="https://www.ireland.ie/en/india/newdelhi" target="_blank" rel="noopener noreferrer">ireland.ie/en/india/newdelhi</a>{' '}
        — official NDVO service page.
      </li>
      <li>
        <a href="https://www.irishimmigration.ie" target="_blank" rel="noopener noreferrer">irishimmigration.ie</a>{' '}
        — Irish Immigration and Naturalisation Service.
      </li>
      <li>
        <a href="https://www.vfsglobal.com" target="_blank" rel="noopener noreferrer">VFS Global</a> — official visa application centre.
      </li>
      <li>Public decisions data published daily by NDVO.</li>
    </ul>

    <h2>3. Who writes our articles</h2>
    <p>
      Articles are written by named contributors with experience in visa
      services, finance, immigration, or international education. Every author
      is listed at the top of each article with their name and credentials.
    </p>

    <h2>4. Review and update cadence</h2>
    <p>
      Priority articles are reviewed at least once per quarter and whenever the
      Irish government announces a change. Every published article shows its
      first-publish and last-updated date at the top.
    </p>

    <h2>5. What we do not do</h2>
    <ul>
      <li>We do not write content that is fabricated, plagiarised, or undisclosed AI-generated.</li>
      <li>We do not provide legal advice. Our content is informational only and is not a substitute for advice from a qualified immigration lawyer.</li>
      <li>We do not accept payment in exchange for a positive review or ranking of any third party.</li>
    </ul>

    <h2>6. Corrections</h2>
    <p>
      If you spot an error, email{' '}
      <a href="mailto:visahelp@irelandvisatracker.in">visahelp@irelandvisatracker.in</a>{' '}
      with the article URL and the suggested correction. We will investigate
      and respond within 5 business days.
    </p>

    <h2>7. Affiliate disclosure</h2>
    <p>
      Some articles link to third-party services. We never accept payment for
      editorial coverage. If we ever earn a commission from a link, we will
      mark it clearly with <code>rel="sponsored"</code>.
    </p>
  </div>
);

export default EditorialPolicyPage;
